import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-black border-neutral-900 lg:border-r lg:pb-32 sticky sm:static top-32 flex-1 flex" }
const _hoisted_2 = { class: "flex flex-col lg:col-span-1 lg:sticky lg:top-0 left-0 lg:h-screen flex-1 lg:overflow-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:block h-32" }, null, -1)
const _hoisted_4 = { class: "space-y-4 lg:py-8 px-8 lg:px-12 lg:max-w-lg" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "title lg:title-2" }, "Need help?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Explore the usage of the Dripversity app and read about the necessary steps to become an owner of the Dripversity NFT. ", -1)
const _hoisted_7 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-8 py-8 px-8 lg:px-12 mt-auto" }
const _hoisted_8 = { class: "title-4" }

import { routes } from "@/constants/";
import AppButtonBackOrHome from "@/components/app/AppButtonBackOrHome.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutSidebarSidebar',
  setup(__props) {

const links = {
    "Getting Started": routes.support,
    "Legal Disclosure": routes.legals,
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(AppButtonBackOrHome),
        _hoisted_5,
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (linkRoutes, linkName) => {
          return _createElementVNode("div", {
            key: linkName,
            class: "space-y-2 p-3 rounded-xl bg-neutral-900"
          }, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(linkName), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkRoutes, (to, routeName) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: linkName + '-' + routeName
                }, [
                  _createVNode(_component_router_link, {
                    class: "link text-sm",
                    to: to
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(routeName), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})